<script setup>
    import axios from 'axios'
    import { defineProps, ref, defineEmits, onMounted } from 'vue'

    import LoadingPage from '@/components/navigation/LoadingPage.vue'

    defineProps({ execButton: { type: String, default: '' } })
    const emit = defineEmits(['layoutContent', 'resetExecButton'])

    const layoutContent = {
        header: {
            title: 'Políticas de privacidade',
        },
    }

    emit('layoutContent', layoutContent)
    const request = ref(false)

    const privacy = ref('')

    function initialize() {
        request.value = true
        axios.get('v1/privacy')
            .then(response => {
                privacy.value = response.data?.data
            })
            .catch(error => {
                console.error(error)
            }).finally(() => {
                request.value = false
            })
    }
    onMounted(() => {
        initialize()
    })
</script>

<template>
    <LoadingPage :show="request" />
    <div
        v-if="!request"
        class="mt-5 text-base text-chat-gray dark:text-gray-400 px-4 pb-2"
        v-html="privacy"
    />
</template>

<style scoped>
  .title {
    @apply text-4xl font-extrabold text-chat-gray-dark tracking-tight sm:text-5xl dark:text-white
  }

  h1 {
    @apply text-xl font-bold text-gray-600 dark:text-gray-800 capitalize mt-4 mb-2;
  }

  p {
    @apply my-2;
  }
</style>
